export const UPDATE_ALBUM_FOLDER_FILENAME_SEARCH =
  'UPDATE_ALBUM_FOLDER_FILENAME_SEARCH';

export const updateAlbumFolderFilenameSearch = (searchQuery, entityId) => ({
  type: UPDATE_ALBUM_FOLDER_FILENAME_SEARCH,
  searchQuery,
  entityId,
});
